import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';

import type { TPassportFormFields } from 'entities/creditForm';

export const useIsShowResidenceFields = () => {
  const { watch } = useFormContext<TPassportFormFields>();
  const isSameAddresses = watch('residenceAddressIsRegistration');

  return !isSameAddresses;
};
